var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircleC(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 47,
    viewBox: "0 0 46 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23.5,
    r: 21.5,
    fill: "white",
    stroke: "#3FC1BE",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.408 32.836C18.92 32.836 15.296 29.62 15.296 23.692C15.296 17.836 19.04 14.428 23.552 14.428C25.808 14.428 27.608 15.484 28.76 16.684L26.888 18.964C25.976 18.076 24.968 17.476 23.6 17.476C20.936 17.476 18.92 19.78 18.92 23.572C18.92 27.46 20.72 29.764 23.552 29.764C25.064 29.764 26.264 29.044 27.2 28.012L29.072 30.244C27.608 31.948 25.712 32.836 23.408 32.836Z",
    fill: "#3FC1BE"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleC);
export default __webpack_public_path__ + "static/media/CircleC.b5d8c360eaaa03594567cf84199642e1.svg";
export { ForwardRef as ReactComponent };